import React from 'react';
import styles from './Logo.module.css';

/**
 * 品牌 Logo - 衬衫 Polo SVG，颜色适配黑色主题
 */
export default function Logo({ size = 28, className = '' }) {
  return (
    <svg
      viewBox="0 0 1024 1024"
      width={size}
      height={size}
      xmlns="http://www.w3.org/2000/svg"
      className={`${styles.logo} ${className}`}
      aria-hidden="true"
    >
      <path
        d="M497.5 452.6c-15.1 0-27.4-12.3-27.4-27.4s12.3-27.4 27.4-27.4 27.4 12.3 27.4 27.4-12.3 27.4-27.4 27.4z m0-34.9c-4.1 0-7.4 3.3-7.4 7.4s3.3 7.4 7.4 7.4 7.4-3.3 7.4-7.4-3.3-7.4-7.4-7.4zM497.5 574.7c-15.1 0-27.4-12.3-27.4-27.4s12.3-27.4 27.4-27.4 27.4 12.3 27.4 27.4-12.3 27.4-27.4 27.4z m0-34.9c-4.1 0-7.4 3.3-7.4 7.4s3.3 7.4 7.4 7.4 7.4-3.3 7.4-7.4-3.3-7.4-7.4-7.4z"
        className={styles.detail}
      />
      <path
        d="M740.7 185l8.1 2.2-25.3-31.3c-3-3.7-7.3-6.2-12-7.1l29.2 36.2zM877.8 264.5c-7.5-10.3-17-18.6-27.1-23.9 6.8 12.1 10.1 24.9 9.5 36.9L830 816.4c-1.6 31-27.8 55.3-59.6 55.3H219.8c-8 0-15.7-1.6-22.7-4.4 8.6 22 30.4 37.4 55.7 37.4h550.6c31.8 0 58-24.3 59.6-55.3l30.2-538.9c0.8-15.1-4.7-31.5-15.4-46z"
        className={styles.shadow}
      />
      <path
        d="M807.5 207.3l-65.7-18-50.5-62.4c-3.1-3.8-7.6-6.2-12.4-6.8-0.2 0-0.3 0.1-0.5 0.1-1.1-0.2-2.2-0.2-3.3-0.2H318c-1 0-2 0-3 0.1-5.2 0.1-10.3 2.4-13.9 6.8l-53.3 65.8-0.9 1.2-59.5 13.1c-0.6 0.1-1.1 0.3-1.6 0.4-31 9.9-54.1 42-52.5 73.1l30.2 539.1c1.6 30.3 27.1 54.3 58.1 54.3h550.6c31 0 56.5-24 58.1-54.2l30.2-539.1c1.7-30.1-23.6-65.2-53-73.3z m-311.3 53.8L367.5 157h257.4L496.2 261.1z m178-96.6l30 37.1-149.6 121.1c-0.6 0.5-1.6 0.4-2.1-0.2l-29.1-35.9 150.8-122.1z m-355.9 0l150.8 122-29.1 36c-0.1 0.1-0.4 0.5-1 0.5-0.6 0.1-1-0.2-1.1-0.3L288.3 201.6l30-37.1z m505.4 114l-30.2 539.3c-0.5 10.6-9.8 19.2-21.1 19.2H221.8c-11.3 0-20.6-8.6-21.2-19.3l-30.2-539c-0.6-12.5 9.9-30.1 26.1-35.7l66.2-14.6L415 351.5c6 5.6 15.2 8.6 24 8.6 1.4 0 2.6-0.1 4-0.2 10.2-1.1 19.4-6.1 25.8-14.1l27.5-34 27.5 34c7.6 9.4 18.7 14.3 30 14.3 8.5 0 17.1-2.8 24.2-8.6l155.8-126 64 17.5c12.7 3.5 26.6 22.5 25.9 35.5z"
        className={styles.main}
      />
    </svg>
  );
}
